import { connect } from 'formik';
import React, { ChangeEvent, Component, PropsWithChildren } from 'react';
import { RegisterElement } from '..';
import { ICheckboxProps } from '../Input';
import { getDescribedBy } from '../Input/inputUtils';
import { FieldHelpersWrapper } from '../utils/formHelpers';
import { resolveProps } from '../utils/formikUtils';
import { createId } from '../utils/IdGenerator';
import './Checkbox.scss';
import { InnerCheckboxProps } from './types';

/**
 * Controlled Input: Checkbox.
 * Use ``<Checkbox />`` when you need to validate a single checkbox as an individual
 * element and provide an individual error message.
 */
export class Checkbox extends Component<PropsWithChildren<InnerCheckboxProps>, {}> {
  private id = this.props.id || createId('checkbox');

  public componentDidMount() {
    this.props.formik.registerField && this.props.formik.registerField(this.props.name, this);
  }

  public componentWillUnmount() {
    this.props.formik.unregisterField && this.props.formik.unregisterField(this.props.name);
  }

  public render() {
    const { id } = this;
    const {
      label = '',
      helpText,
      onChange,
      displaySuccess = false,
      formik,
      required,
      validate,
      groupLabel,
      'qa-id': qaID,
      ...inputAttrsProps
    } = this.props;
    const { checked, valid = true, touched = false, onBlur } = resolveProps(this.props, this.props.formik);
    const showError = touched && !valid;
    const describedBy = getDescribedBy({
      hasErrors: showError,
      hasHelpText: !!helpText,
      id,
    });
    return (
      <RegisterElement name={`register-${id}`}>
        {(ref: any) => {
          const myRef = showError ? ref : undefined;
          return (
            <div ref={myRef} id={`${id}-wrapper`} className={'checkbox hlc-checkbox'} qa-id={qaID}>
              <FieldHelpersWrapper id={id} props={this.props} useGroupLabel={true}>
                <label>
                  <input
                    id={id}
                    type={'checkbox'}
                    required={!!required}
                    onBlur={onBlur}
                    aria-invalid={!valid}
                    aria-describedby={describedBy}
                    {...inputAttrsProps}
                    checked={checked}
                    onChange={this.handleChange}
                  />{' '}
                  {label}
                </label>
              </FieldHelpersWrapper>
            </div>
          );
        }}
      </RegisterElement>
    );
  }

  private handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    const { formik, onChange, name } = this.props;
    if (onChange) {
      onChange(name, checked);
    } else if (formik && formik.handleChange) {
      formik.handleChange(e);
    }
  };
}

export default connect<ICheckboxProps>(Checkbox);
